<template>
  <div v-if="pageRendered">
    <div class="row" ref="editor">
      <template v-if="editing">
        <div class="col" >
          <BooleansToInclude @configChanged="updateConfig($event)" :currentConfig="config"></BooleansToInclude>
        </div>
        <div v-if="getAmountOfBooleansSelected > 1" class="col-4">
          <label>{{  $t('insights.ui.booleanSumType.question') }}</label>
          <div class="custom-control custom-radio">
            <input type="radio" :id="'boolean-sum-all-'+ this.uniqueId" name="boolean-sum"
                   value="sumAll"
                   @change="setSumType($event)"
                   class="custom-control-input" v-model="tempConfig.sumType">
            <label class="custom-control-label"
                   :for="'boolean-sum-all-'+ this.uniqueId">{{ $t('insights.ui.booleanSumType.answers.sumAll') }}</label>
          </div>
          <div class="custom-control custom-radio">
            <input type="radio" :id="'boolean-sum-unique-'+ this.uniqueId" name="boolean-sum"
                   value="sumUnique"
                   @change="setSumType($event)"
                   class="custom-control-input" v-model="tempConfig.sumType">
            <label class="custom-control-label"
                   :for="'boolean-sum-unique-'+ this.uniqueId">{{ $t('insights.ui.booleanSumType.answers.sumUniqueJobs') }}</label>
          </div>
        </div>
        <div class="col-4">
          <label for="title-booleans">{{ $t('ui.title') }}</label>
          <input type="text" id="title-booleans" class="form-control" v-model="config.title">
        </div>
      </template>
    </div>
    <div class="row" v-if="!editing">
      <div class="amount-container">
        <div class="col-12">
          <h1>{{ config.title }}</h1>
        </div>
        <div class="col-12">
          <div class="amount">
            {{ getAmount }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import generalMethods from "@/mixins/insights/generalMethods";
import BooleansToInclude from "@/components/insights/forms/BooleansToInclude";

export default {
  components: {
    BooleansToInclude
  },
  mixins: [ generalMethods],
  props: ['editing'],
  data() {
    return {
      uniqueId: _.uniqueId(),
      fsQueries: {},
      currentBounds: [],
      amount: 0,
      config: { booleansToCount: {}, title: '', sumType: 'sumAll' },
      loading: true,
      pageRendered: false,
      tempConfig: {
        booleansToInclude: [],
        sumType: 'sumAll'
      }
    }
  },
  firestore() {
    return {

    }
  },
  computed: {
    ...mapGetters('company', ['getConfig']),
    ...mapGetters('users', ['getClaims']),
    getBooleansToCount() {
      return this.getConfig.booleansToCount;
    },
    getAmountOfBooleansSelected() {
      if (this.config.componentConfig && this.config.componentConfig.booleansToCount) {
        return _.size(_.filter(_.toArray(this.config.componentConfig.booleansToCount), b => !!b))
      } else {
        return 0;
      }
    },
    getBoundProperties() {
      return _.map(this.currentBounds, bound => {
        return this.fsQueries[bound]
      })
    },
    getAmount() {
      return this.calculateAmount(this.getBoundProperties);
    }
  },
  methods: {
    calculateAmount(boundProperties) {
      let jobIds = [];
      _.forEach(boundProperties, bound => {
        jobIds = jobIds.concat(_.map(bound, 'id'))
      })

      if (this.config.componentConfig.sumType === 'sumAll') {
        return _.size(jobIds);
      } else {
        return _.size(_.uniq(jobIds))
      }
    },
    setSumType(event) {
      this.config.componentConfig.sumType = event.srcElement.value;
      this.emitConfig();
    },
    updateConfig(newConfig) {
      this.config = newConfig;
    },
    updateFirestore() {
      // Unbind the current bounds because the queries might have changed
      _.forEach(this.currentBounds, currentBound => {
        this.$unbind('fsQueries. ' + currentBound);
      });
      this.currentBounds = [];
      if (this.config.componentConfig) {
        const initialQueries = {};
        _.forEach(this.config.componentConfig.booleansToCount, (count, property) => {
          initialQueries['fsQuery' + property] = [];
        });
        this.fsQueries = initialQueries;
        _.forEach(this.config.componentConfig.booleansToCount, (count, property) => {
          if(count) {
            let userClaims = this.getClaims;
            this.$bind('fsQueries.fsQuery' + property, this.$FB.collection('jobs')
                .where('companyId', '==', userClaims.companyId)
                .where(property, '==',true));

            this.currentBounds.push('fsQuery' + property)
          }
        });
      } else {
        this.fsQueries = {};
      }
    },
  },
  created() {
    setTimeout(() => {
      if (!this.config.componentConfig) {
        this.config.componentConfig = { sumType: 'sumAll' };
      }
      this.updateFirestore();
      this.pageRendered = true; }, 500);
  },
  watch: {
    'config'(newValue, oldValue) {
       if (!_.isEqual(_.omit(newValue, ['title']), _.omit(oldValue, ['title'])) && this.pageRendered) {
        this.updateFirestore();
      }
    },
  }
}
</script>

<style scoped lang="scss">
@import "./src/assets/scss/components/insights/_generalStylingCharts.scss";

.amount-container {
  display: grid;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.amount {
  font-size: 5rem;
  font-weight: bold;
}

</style>